import Hero from './Hero';
import HeroContainer from './Hero.container';

export default HeroContainer(Hero);
